var _circle, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreece(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#f0f0f0",
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#338af3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256 189.217h247.181c-6.419-23.814-16.175-46.255-28.755-66.783h-218.426z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.643 456.348h318.713c23.363-18.608 43.399-41.21 59.069-66.783h-436.851c15.671 25.572 35.707 48.175 59.069 66.783z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.043 61.939c-20.126 17.331-37.525 37.74-51.469 60.496h51.469z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 256c0-26.076 0-47.899 0-66.783h-100.174v66.783h-66.783v-66.783h-80.224c-5.739 21.294-8.819 43.676-8.819 66.783s3.08 45.489 8.819 66.783h494.363c5.738-21.294 8.818-43.676 8.818-66.783z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 0c-35.549 0-69.404 7.253-100.174 20.348v102.087h100.174c0-23.312 0-43.139 0-66.783h159.357c-43.731-34.828-99.108-55.652-159.357-55.652z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreece);
export default __webpack_public_path__ + "static/media/greece.cca5d008150036b0f273b35da063210e.svg";
export { ForwardRef as ReactComponent };